import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import colors from 'src/styles/colors.module.scss';
import Selectors from 'src/utils/selectors';
import FormatService from 'src/services/format.service';
import React from 'react';
import styles from './transactionAmount.module.scss';

interface Props {
    amount: number;
    variant?: DlsTypographyVariants;
}

export default function TransactionAmount({ amount, variant }: Props): JSX.Element {
    return (
        <p
            className={`${variant ?? DlsTypographyVariants.BODY_1} ${-amount > 0 ? colors.success : ''} ${
                styles.nowrap
            }`}
            data-cy={Selectors.Transactions.AMOUNT_VALUE}
        >
            {FormatService.formatCurrency(-amount)}
        </p>
    );
}
